
import {combineReducers}   from 'redux';
import fuse                from './fuse';
import auth                from 'auth/store/reducers/index';
import quickPanel          from 'main/quickPanel/store/reducers';
import example             from 'main/content/example/store/reducers/index';
import studentApp          from 'main/content/student/store/reducers/index';
import dashboardApp        from 'main/content/dashboard/store/reducers/index';
import medprocure          from './medprocure';
import majorApp            from 'main/content/major/store/reducers/index';
import courseApp           from 'main/content/course/store/reducers/index';
import lessonApp           from 'main/content/lesson/store/reducers/index';
import assignmentApp       from 'main/content/assignment/store/reducers/index';
import instructorApp       from 'main/content/instructor/store/reducers/index';
import moduleApp           from 'main/content/module/store/reducers/index';
import quizApp             from 'main/content/quiz/store/reducers/index';
import companyApp          from 'main/content/company/store/reducers/index';
import assetApp            from 'main/content/asset/store/reducers/index';
import questionApp         from 'main/content/question/store/reducers/index';
import timer               from 'main/components/timer/store/reducers/index';
import note                from 'main/components/note/store/reducers/index';
import scheduledCourseApp  from 'main/content/scheduled_course/store/reducers/index';
import validator           from 'main/components/validator/store/reducers/index';
import gradebookApp        from 'main/content/gradebook/store/reducers/index';
import enrollmentApp       from 'main/content/enrollment/store/reducers/index';
import paramHistory        from 'main/components/paramHistory/store/reducers/index';
import qualificationApp    from 'main/content/qualification/store/reducers/index';
import tableSort           from 'main/components/tableSort/store/reducers/index';
import notification        from 'main/content/notification/store/reducers/index';
import permissionApp       from 'main/content/permission/store/reducers/index';
import utilReducer         from 'main/content/utils/store/reducers/index';
import contentLabelReducer from 'main/content/content_label/store/reducers/index';
import tableFilter         from 'main/components/tableFilter/store/reducers/index';
import progressApp         from 'main/content/progress/store/reducers/index';

const rootReducer = combineReducers({
    auth,
    fuse,
    medprocure,
    quickPanel,
    example,
    studentApp,
    dashboardApp,
    majorApp,
    courseApp,
    lessonApp,
    assignmentApp,
    instructorApp,
    moduleApp,
    quizApp,
    companyApp,
    assetApp,
    timer,
    questionApp,
    note,
    scheduledCourseApp,
    validator,
    gradebookApp,
    paramHistory,
    qualificationApp,
    enrollmentApp,
    paramHistory,
    tableSort,
    notification,
    permissionApp,
    utilReducer,
    contentLabelReducer,
    tableFilter,
    progressApp
});

export default rootReducer;


// WEBPACK FOOTER //
// src/store/reducers/index.js